module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/mobile-404@2x_6e91d8.jpg";